import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetDistributorTypesResponse,
  TDistributorType,
  TDistributorTypeFilter,
  TDistributorTypeForm,
} from "../types/distributorTypes.types";
import axiosTeethTab from "../../../services/apiCall";

type DistributorTypeApiInterface = {
  getDistributorTypes: (
    filter: TDistributorTypeFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetDistributorTypesResponse>>;
  saveDistributorType: (
    distributorType: TDistributorTypeForm,
  ) => Promise<ApiResponse<TDistributorType>>;
  enable: (id: string) => Promise<ApiResponse<TDistributorType>>;
  disable: (id: string) => Promise<ApiResponse<TDistributorType>>;
};

const distributorTypeApi: DistributorTypeApiInterface = {
  getDistributorTypes: async (filter, pagination) => {
    return await axiosTeethTab.get("distributor-types", {
      params: { filter, pagination },
    });
  },
  saveDistributorType: async (distributorType) => {
    const endpoint = distributorType._id
      ? `distributor-types/${distributorType._id}`
      : "distributor-types";
    return await axiosTeethTab.post<TDistributorType>(endpoint, distributorType);
  },
  enable: async (id) => {
    return await axiosTeethTab.patch<TDistributorType>(
      `distributor-types/${id}/enable`,
    );
  },
  disable: async (id) => {
    return await axiosTeethTab.patch<TDistributorType>(
      `distributor-types/${id}/disable`,
    );
  },
};

export default distributorTypeApi;
